import React, { Component } from 'react';
import * as moment from 'moment';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import Status from '../../../../config/OrderStatusConstants.js'
import { Button, Divider } from 'semantic-ui-react'
import { getOrderKey } from '../../../../config/constants';

export class MarkAutoSendDesign extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    markAutoDesignSend = () => {
        console.log("funk1 ++++: markAutoDesignSend");
        console.log("funk12 email:" + this.props.user.email);
        console.log("funk13 status:" + this.props.status);

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {}

        if (this.props.order.design_auto_sent) {
            console.log("funk14 this.props.order.design_auto_sent:" + this.props.order.design_auto_sent)
            orderUpdates = {
                design_auto_sent: false,
                design_auto_sent_lastUpdate: now,
            }
        } else {
            orderUpdates = {
                design_auto_sent: true,
                design_auto_sent_lastUpdate: now,
               // whatsApp_avail: true
            }
        }

        //FbUtils.updateOrder(this.props.order.key, orderUpdates);
        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);
    }

    render() {

        const showAutoSent = this.props.order.design_auto_sent
            ? <h4>Design Auto send: ON</h4>
            : <h4>Design Auto send: OFF</h4>

        const showAutoSentButtons = this.props.order.design_auto_sent
            ? <Button fluid color='yellow' onClick={this.markAutoDesignSend}> TURN OFF  </Button>
            : <Button fluid color='teal' onClick={this.markAutoDesignSend}> TURN ON  </Button>

        const wholeUi = this.props.algoliaUser && this.props.algoliaUser.design_auto_sent
            ? <div><Divider horizontal>{'AUTO SEND DESIGN'}</Divider>
            {/* <Button color='yellow' onClick={this.markAutoDesignSend}> AUTO SEND </Button> */}
            {showAutoSentButtons}
            {showAutoSent}</div>
            :''

        return (
            <div>
                {wholeUi}

            </div>

        )
    }
}

export default MarkAutoSendDesign;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Whatsapp/MarkAutoSendDesign.js